module.exports = "/static/assets/0d8a4051e53c3ac3a9fb2a1c7515b9f8.gif";